"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auctioneerBeet = exports.Auctioneer = void 0;
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const auctioneerDiscriminator = [46, 101, 92, 150, 138, 30, 245, 120];
class Auctioneer {
    constructor(auctioneerAuthority, auctionHouse, scopes) {
        this.auctioneerAuthority = auctioneerAuthority;
        this.auctionHouse = auctionHouse;
        this.scopes = scopes;
    }
    static fromArgs(args) {
        return new Auctioneer(args.auctioneerAuthority, args.auctionHouse, args.scopes);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return Auctioneer.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find Auctioneer account at ${address}`);
        }
        return Auctioneer.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.auctioneerBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.auctioneerBeet.serialize({
            accountDiscriminator: auctioneerDiscriminator,
            ...this,
        });
    }
    static get byteSize() {
        return exports.auctioneerBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(Auctioneer.byteSize, commitment);
    }
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === Auctioneer.byteSize;
    }
    pretty() {
        return {
            auctioneerAuthority: this.auctioneerAuthority.toBase58(),
            auctionHouse: this.auctionHouse.toBase58(),
            scopes: this.scopes,
        };
    }
}
exports.Auctioneer = Auctioneer;
exports.auctioneerBeet = new beet.BeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['auctioneerAuthority', beetSolana.publicKey],
    ['auctionHouse', beetSolana.publicKey],
    ['scopes', beet.uniformFixedSizeArray(beet.bool, 7)],
], Auctioneer.fromArgs, 'Auctioneer');
//# sourceMappingURL=Auctioneer.js.map